export default __webpack_public_path__ + "static/media/trailer-white.bb3984c0.svg";